
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round","stroke":"currentColor"}},[_c('path',{attrs:{"d":"M15.5 12H20M11 5h9M11 19h9"}})]),_c('g',{attrs:{"fill":"currentColor","stroke":"currentColor","stroke-width":"2"}},[_c('path',{attrs:{"d":"M7 5l-1.5.866V4.134L7 5zM11 12l-1.5.866v-1.732L11 12zM7 19l-1.5.866v-1.732L7 19z"}})])])
          )
        }
      }
    